<template>
    <div class="container">
        <div class="row">
            <div class="col-xl-6 col-md-6">
                <ul class="list-unstyled feature-one__point">
                    <li>
                         <div class="justifi2 sub-title" style="color: #a8cf36; font-size: 1.2rem;">
                            <p>Servicios Eléctricos que Ofrecemos</p>
                         </div>
                    </li>

                    <li>
                        <div >
                             <span class="fa fa-check alinear"></span>
                        </div>
                         <div class="justifi2 justifi">
                            <p >Instalaciones y montajes eléctricos en media y baja tensión.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check alinear"></span>
                        </div>
                         <div class="justifi2">
                            <p >Mantenimientos eléctricos preventivos y correctivos.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check alinear"></span>
                        </div>
                         <div class="justifi2">
                            <p >Reparación de instalaciones eléctricas.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check alinear"></span>
                        </div>
                         <div class="justifi2">
                            <p >Diseño y creación de tableros de fuerza y control.</p>
                         </div>
                    </li>
                </ul>
                  <!-- <i class="fas fa-check"></i> -->
                  <!-- <i class="far fa-check-circle"></i> -->
            </div>
            <!-- 2 -->
            <div class="col-xl-6 col-md-6">
                <ul class="list-unstyled feature-one__point">
                    <li>
                         <div class="justifi2 sub-title" style="color: #a8cf36; font-size: 1.2rem;">
                            <p>Servicios Hidráulicos y de Bombeo</p>
                         </div>
                    </li>

                    <li>
                        <div >
                             <span class="fa fa-check alinear"></span>
                        </div>
                         <div class="justifi2">
                            <p>Extracción e instalación de bombas de pozo profundo.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check alinear"></span>
                        </div>
                         <div class="justifi2">
                            <p>Pruebas de bombeo y puesta en marcha.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check alinear"></span>
                        </div>
                         <div class="justifi2">
                            <p >Sistema de impulsión de agua.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check alinear"></span>
                        </div>
                         <div class="justifi2">
                            <p >Sistema de riego tecnificado.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check alinear"></span>
                        </div>
                         <div class="justifi2">
                            <p >Mantenimiento y reparación de equipos de bombeo.</p>
                         </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row">
            <p class="justifi alinear" style="margin-bottom: 30px">
                En IEH, acompañamos a nuestros clientes en cada etapa de sus proyectos eléctricos e hidráulicos: 
                desde la planificación y ejecución, hasta la puesta en marcha y el mantenimiento preventivo y correctivo. 
                Nuestro equipo técnico se dedica a resolver cualquier problema que pueda surgir, 
                garantizando la continuidad y eficiencia de sus operaciones.
            </p>

            <p class="justifi alinear" style="margin-bottom: 30px">
                Trabajamos con el máximo compromiso, profesionalismo y ética, atendiendo tanto a clientes particulares como a empresas. Solicite su 
                presupuesto sin compromiso y descubra cómo podemos apoyarlo en la optimización y seguridad de sus instalaciones.
            </p>
        </div>

    </div>
</template>
    <style>
        .justifi{
            text-align: justify;
            
        }
        .justifi2{
            text-align: justify;
            /* font-family: Arial, Helvetica, sans-serif !important;  */
            font-weight: 0px !important;
            /* color: #2c3e50 !important; */
            margin-left: 14px;
        }

        .sub-title{
                margin-bottom: 20px;
        }

        .alinear{
            margin-left: 14px;
        }

        
        @media only screen and (max-width: 414px){
            .alinear {
                margin-left: 0px;
            }
        }
        
    </style>
<script>
</script>